import { createFileRoute } from '@tanstack/react-router'
import { TimesheetReviewPage } from '@/common/components/timesheet-review-page/TimesheetReviewPage'

export const Route = createFileRoute('/manager/review/$timesheetId')({
  component: ReviewRoute,
})

function ReviewRoute() {
  const { timesheetId } = Route.useParams()
  const id = Number(timesheetId)

  if (!id || isNaN(id)) {
    return <div style={{ padding: 32 }}>Invalid timesheet ID.</div>
  }

  return <TimesheetReviewPage timesheetId={id} />
}
